import React, {useState} from "react";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import apiPost from "../../api/apiPost";
import {ENDPOINT_PROCESS_PAYMENT} from "../../consts/apiConsts";
import IconHeading from "../../../Icons/IconHeading";
import Loading from "../../Loader/Loading";
import dataLayerHandler, {
  CARD_DETAILS_COMPLETE,
  CARD_DETAILS_ERROR, CARD_DETAILS_INCOMPLETE, TRIP_CONFIRMED,
  TRIP_PAYMENT
} from "../../dataLayer/dataLayerHandler";

const PaymentForm = (props) => {

  const stripe = useStripe();
  const elements = useElements();

  const {
    config
  } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [terms, setTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements || !terms) {
      return;
    }

    setError(null);
    const ele = elements.getElement(CardElement);
    const { paymentMethod, methodError } = await stripe.createPaymentMethod({
      type: 'card',
      card: ele,
    });

    if (methodError) {
      setError(methodError);
    }

    if (paymentMethod) {
      dataLayerHandler(TRIP_CONFIRMED, config.total_d);
      setLoading(true);
      window.setTimeout(async () => {
        const json = await apiPost(
          ENDPOINT_PROCESS_PAYMENT,
          {
            'method': paymentMethod.id
          }
        );

        if (json.error) {
          setLoading(false);
          setError(json.error_message);
        } else {
          window.location = json.redirect_link;
        }
      }, 100);
    }
  }

  const onCardChange = (event) => {
    if (event.complete) {
      dataLayerHandler(CARD_DETAILS_COMPLETE);
    } else if (event.error) {
      dataLayerHandler(CARD_DETAILS_ERROR);
    } else {
      dataLayerHandler(CARD_DETAILS_INCOMPLETE);
    }
  }

  return <form onSubmit={handleSubmit} className={'booking__payments'}>
    <div className="booking__section">
      <div className="booking__yourDetail">
        <div className="booking__title">
          <div className="booking__headIcon">
            <IconHeading />
          </div>
          <h3>Card Details</h3>
        </div>
      </div>
      <div>
        <CardElement
          onChange={onCardChange}
          options={{
            appearance: {
              theme: 'stripe'
            }
          }}
        />
      </div>
    </div>
    {!!error && <div className={'error'}>
      <p>{error}</p>
    </div>}
    <div className="booking__accept__terms">
      <p>
        <input
          checked={terms}
          aria-labelledby="checked"
          type={"checkbox"}
          onChange={() => {
            setTerms(!terms)
          }}
        />
        I have read and accept the terms and conditions for this booking, found <a href={config.terms} target={'_blank'}>here</a>
      </p>
    </div>
    <div className="booking__confirm">
      <button
        disabled={!stripe || loading}
        type={'submit'}
        className="btn btn--lg">
        {loading ? <Loading /> : 'COMPLETE'}
      </button>
    </div>
  </form>

}

export default PaymentForm;
